import { cn } from '@/lib/cn';

type CodeBlockProps = { code: string; label?: string; className?: string };

/** Read-only code with line numbers on the code-bg surface. */
export function CodeBlock({ code, label = 'Code', className }: CodeBlockProps) {
  const lines = code.split('\n');
  return (
    <pre
      aria-label={label}
      // A horizontally scrollable region must be reachable by keyboard (axe: scrollable-region-focusable).
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      className={cn(
        'm-0 overflow-x-auto bg-code-bg px-6 py-5 font-mono text-sm leading-[1.7] text-code-text',
        className,
      )}
    >
      <code>
        {lines.map((line, i) => (
          <span key={i} className="block whitespace-pre">
            <span
              aria-hidden="true"
              className="mr-4 inline-block w-4 select-none text-right text-code-line-number"
            >
              {i + 1}
            </span>
            {line || ' '}
          </span>
        ))}
      </code>
    </pre>
  );
}
